import { AxiosResponse, AxiosError } from "axios";
//import Analytics from "../classes/Analytics";
import { validationUtils } from "../validation/Validation";
import { eventEmitter } from "../classes/EventEmitter";
import appStore from '../state/store';
import { EVENTS, NO_QUOTE_LABEL } from "../AppConstants";
import { createBrowserHistory } from 'history';
import * as _ from 'lodash';

export const successResponseInterceptor = (response: AxiosResponse<any>) => {
    return response;
};

export const errorResponseInterceptor = (error: AxiosError<any>) => {
    if (error.response && 400 === error.response.status && error.response.data && error.response.data.validationErrors) {
        const validationResult = validationUtils.translateServerValidationResult(error.response.data.validationErrors);
        validationUtils.publishValidationFailure(validationResult);
        return Promise.reject();
    }

    if (error.response && 400 === error.response.status && error.response.data && error.response.data.errorMessage) {
        eventEmitter.publish(EVENTS.API_CALL_FAILURE_BAD_REQUEST, { errorMessage: error.response.data.errorMessage });
    } else {
        eventEmitter.publish(EVENTS.API_CALL_FAILURE_COMMON, { error: error.response });
    }

    if (error.response && 401 === error.response.status && error.response.data) {
        eventEmitter.publish(EVENTS.UNAUTHORIZED, { errorMessage: "UNAUTHORIZED" });
    }

    //const appState = appStore.getState();
    //const label = appState?.quoteId?.toString() ?? NO_QUOTE_LABEL;

    //const history = createBrowserHistory();
    //Analytics.onAjaxError(label, error, history.location.pathname);

    return Promise.reject(error);
};